import swtAlert from "lib/sweetAlert";
import {
  AUTH_STORAGE_KEY,
  REFRESH_TOKEN_STORAGE_KEY,
} from "lib/apiUrl";

function clearStoredAuthTokens() {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(AUTH_STORAGE_KEY);
  window.localStorage.removeItem(REFRESH_TOKEN_STORAGE_KEY);
}

let sessionExpiredHandler = null;
let handlingSessionExpiry = false;

export function registerSessionExpiredHandler(handler) {
  sessionExpiredHandler = typeof handler === "function" ? handler : null;
}

function collectSessionMessageParts(errorOrPayload) {
  if (!errorOrPayload) return [];
  if (typeof errorOrPayload === "string") return [errorOrPayload];
  const parts = [
    errorOrPayload.message,
    errorOrPayload.error,
    errorOrPayload.data?.message,
    errorOrPayload.data?.error,
  ];
  return parts.filter((part) => typeof part === "string" && part.trim());
}

export function getSessionExpiredMessage(errorOrPayload) {
  const combined = collectSessionMessageParts(errorOrPayload).join(" ").toLowerCase();
  if (!combined) return null;

  const isSessionMessage =
    combined.includes("invalid or expired session") ||
    combined.includes("expired session") ||
    combined.includes("session expired") ||
    combined.includes("invalid session") ||
    combined.includes("token expired") ||
    combined.includes("jwt expired");

  if (!isSessionMessage) return null;

  return (
    collectSessionMessageParts(errorOrPayload)[0] ||
    "Your session is invalid or has expired. Please sign in again."
  );
}

export function isSessionExpiredError(error, { httpStatus } = {}) {
  if (httpStatus === 401 || httpStatus === 403) {
    return true;
  }
  return Boolean(getSessionExpiredMessage(error));
}

export function isSessionExpiredPayload(payload) {
  if (!payload || typeof payload !== "object") return false;
  if (payload.status === false || payload.success === false || payload.ok === false) {
    return Boolean(getSessionExpiredMessage(payload));
  }
  return Boolean(getSessionExpiredMessage(payload));
}

/**
 * Shows a single alert, clears tokens, then runs the app-registered logout handler.
 */
export async function handleSessionExpired(message) {
  if (handlingSessionExpiry) return;
  handlingSessionExpiry = true;

  try {
    await swtAlert.warning(
      "Session expired",
      message ||
        "Your session is invalid or has expired. Please sign in again."
    );

    clearStoredAuthTokens();

    if (sessionExpiredHandler) {
      await sessionExpiredHandler();
    }
  } finally {
    handlingSessionExpiry = false;
  }
}
